/* PublicSobre — Página institucional sobre o projeto. */
import { Anchor, Telescope, GitBranch, ShieldCheck, BookOpen } from "lucide-react";

export default function PublicSobre() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 space-y-10" data-testid="public-sobre-page">
      <header>
        <div className="text-[10px] font-mono uppercase tracking-widest text-amber-700">LSC · EGN</div>
        <h1 className="font-display font-bold text-4xl md:text-5xl text-[#0a2342] mt-2">Sobre o Projeto Nostradamus</h1>
        <p className="text-lg text-slate-600 mt-3 leading-snug">
          Observatório institucional de Sementes de Futuro em Segurança Pública &amp; Defesa
        </p>
      </header>

      <section className="prose prose-slate max-w-none">
        <p className="text-slate-700 leading-relaxed">
          O <strong>Projeto Nostradamus</strong> é uma iniciativa do <strong>Laboratório de Simulações e Cenários
          da Escola de Guerra Naval (LSC/EGN)</strong>, dedicado a coletar, classificar, analisar e visualizar
          literatura acadêmica e cinzenta sobre estudos de futuro com horizonte superior a 2030, com foco em
          Segurança Pública, Segurança Internacional e Defesa.
        </p>
      </section>

      <section className="grid md:grid-cols-2 gap-6">
        <Card icon={Telescope} title="Monitoramento Prospectivo">
          Coleta semanal automática em fontes científicas abertas (Crossref, OpenAlex, Semantic Scholar) e
          repositórios institucionais.
        </Card>
        <Card icon={GitBranch} title="Metodologia V2">
          Pipeline rigoroso Fonte → Insumo → Semente, com revisão humana obrigatória e auditoria de cada etapa.
        </Card>
        <Card icon={ShieldCheck} title="Revisão Humana Obrigatória">
          Nenhuma classificação automática é aprovada sem validação de coordenadores e revisores institucionais.
        </Card>
        <Card icon={BookOpen} title="Transparência Pública">
          Dados agregados anônimos são disponibilizados nesta área pública. Dados sensíveis e documentos
          completos permanecem na base institucional restrita.
        </Card>
      </section>

      <section>
        <h2 className="font-display font-bold text-2xl text-[#0a2342] mb-4">9 Vetores Oficiais</h2>
        <ol className="grid md:grid-cols-2 gap-2 text-sm text-slate-700">
          <li>1. Garantia da Lei e da Ordem (GLO)</li>
          <li>2. Segurança de Fronteiras e Combate a Ilícitos Transnacionais</li>
          <li>3. Segurança Marítima, Naval e Hidroviária</li>
          <li>4. Inteligência de Defesa aplicada à Segurança Pública</li>
          <li>5. Apoio Logístico e Operacional a Órgãos Civis / Interagências</li>
          <li>6. Defesa Civil, Eventos Extremos e Crises Internas</li>
          <li>7. Segurança de Grandes Eventos e Proteção de Autoridades</li>
          <li>8. Prevenção e Combate ao Terrorismo</li>
          <li>9. Repressão aos Ilícitos Ambientais</li>
        </ol>
      </section>

      <section className="bg-slate-50 border border-slate-200 rounded p-6">
        <Anchor size={18} className="text-amber-500 mb-2" />
        <h3 className="font-display font-bold text-lg text-[#0a2342] mb-2">Escola de Guerra Naval</h3>
        <p className="text-sm text-slate-700 leading-relaxed">
          A EGN é a instituição de altos estudos militares-navais da Marinha do Brasil, responsável pela
          formação estratégica de oficiais e pela produção de conhecimento em defesa, segurança e estudos
          marítimos.
        </p>
      </section>
    </div>
  );
}

function Card({ icon: Icon, title, children }) {
  return (
    <div className="bg-white border border-slate-200 rounded p-5 hover:border-amber-300 transition">
      <Icon size={20} className="text-amber-500 mb-3" />
      <h3 className="font-display font-bold text-lg text-[#0a2342] mb-2">{title}</h3>
      <p className="text-sm text-slate-600 leading-relaxed">{children}</p>
    </div>
  );
}
